export enum ERouteNames {
  HOME = 'home',
  ADMIN_NAV = 'admin',
  NOT_FOUND = 'not-found',
  PAYMENT = 'payment',
  SERVERS = 'servers',
  USERS = 'users',
  MESSAGES = 'messages',
  WORKS = 'works',
  STATISTICS = 'statistics',
  SETTINGS = 'settings',
  GUIDES = 'guides',
  TRANSACTIONS = 'transactions',
  AUTH = 'auth',
  MAGIC_LINK = 'magic-link',
  PROFILE = 'profile',
  LEADERBOARD = 'leaderboard',
  CONSOLE = 'console',
}
